/**
 * @description 查詢系統訊息代號 訊息代號 (CODE_ID) 參數用
 */
export enum CodeId {
  B001 = 'B001',
  B002 = 'B002',
  B003 = 'B003',
  B004 = 'B004',
  B005 = 'B005',
  B006 = 'B006',
  HEAD = 'HEAD',
  U001 = 'U001',
  U002 = 'U002',
  U003 = 'U003',
  U004 = 'U004',
  U005 = 'U005',
  U006 = 'U006',
  U007 = 'U007',
  U008 = 'U008',
  U009 = 'U009',
  U010 = 'U010',
  U011 = 'U011',
  U012 = 'U012',
  U013 = 'U013',
  U014 = 'U014',
  U015 = 'U015',
  U016 = 'U016',
  U017 = 'U017',
  U018 = 'U018',
  U019 = 'U019',
  U020 = 'U020',
  U021 = 'U021',
  U022 = 'U022',
  U023 = 'U023',
  U024 = 'U024',
  U025 = 'U025',
  U026 = 'U026',
  U027 = 'U027',
  U028 = 'U028',
  U029 = 'U029',
  U030 = 'U030',
  U031 = 'U031',
  U032 = 'U032',
  U033 = 'U033',
  U034 = 'U034',
  U035 = 'U035',
  U036 = 'U036',
  U037 = 'U037',
  U038 = 'U038',
  U039 = 'U039',
  U040 = 'U040',
  U041 = 'U041',
  U042 = 'U042',
  U043 = 'U043',
  U044 = 'U044',
  U045 = 'U045',
  U046 = 'U046',
  U047 = 'U047',
  U049 = 'U049',
  U050 = 'U050',
  U051 = 'U051',
  U052 = 'U052',
  U201 = 'U201',
  U202 = 'U202',
  U203 = 'U203',
  U204 = 'U204',
  U205 = 'U205',
  U206 = 'U206',
  U207 = 'U207',
  U208 = 'U208',
  QC01 = 'QC01',
  QC02 = 'QC02',
  QC03 = 'QC03',
  QC04 = 'QC04',
  QC05 = 'QC05',
  QC06 = 'QC06',
  M001 = 'M001',
  PV01 = 'PV01',
  PV02 = 'PV02',
  PV13 = 'PV13',
  PV14 = 'PV14',
  CCBANK = 'CCBANK',
  COOKIE = 'COOKIE',
  TRRM01 = 'TRRM01',
  TRRM02 = 'TRRM02',
  TRRM03 = 'TRRM03',
  TRRM04 = 'TRRM04',
  TRRM05 = 'TRRM05',
  TRRM06 = 'TRRM06',
  TRRM07 = 'TRRM07',
  TRRM08 = 'TRRM08',
  T002 = 'T002',
  T001 = 'T001',
  W001 = 'W001',
  W002 = 'W002',
  W003 = 'W003',
  W004 = 'W004',
  W005 = 'W005',
  W006 = 'W006',
  W007 = 'W007',
  W008 = 'W008',
  W009 = 'W009',
  W010 = 'W010',
  W011 = 'W011',
  W022 = 'W022',
  W023 = 'W023',
  W024 = 'W024',
  W025 = 'W025',
  W026 = 'W026',
  W027 = 'W027',
  W028 = 'W028',
  W029 = 'W029',
  W030 = 'W030',
  W031 = 'W031',
  W032 = 'W032',
  W033 = 'W033',
  W034 = 'W034',
  W035 = 'W035',
  W036 = 'W036',
  W037 = 'W037',
  W038 = 'W038',
  W039 = 'W039',
  W040 = 'W040',
  W041 = 'W041',
  W042 = 'W042',
  W043 = 'W043',
  W044 = 'W044',
  W045 = 'W045',
  W046 = 'W046',
  W047 = 'W047',
  W048 = 'W048',
  W049 = 'W049',
  W050 = 'W050',
  W051 = 'W051',
  W052 = 'W052',
  W053 = 'W053',
  W054 = 'W054',
  W055 = 'W055',
  W056 = 'W056',
  W057 = 'W057',
  W058 = 'W058',
  W059 = 'W059',
  W060 = 'W060',
  W061 = 'W061',
  W062 = 'W062',
  W063 = 'W063',
  W064 = 'W064',
  W065 = 'W065',
  W066 = 'W066',
  W067 = 'W067',
  W068 = 'W068',
  W071 = 'W071',
  W072 = 'W072',
  W073 = 'W073',
  W075 = 'W075',
  W077 = 'W077',
  W082 = 'W082', // 地區卡控文字範本 1 (方案A、國家A)
  W083 = 'W083', // 地區卡控文字範本 2 (方案A、國家B)
  W084 = 'W084', // 地區卡控文字範本 3 (方案B、國家A)
  W085 = 'W085', // 地區卡控文字範本 4 (方案B、國家B)
  W086 = 'W086',
  W088 = 'W088',
  W200 = 'W200',
  W201 = 'W201',
  CSD01 = 'CSD01',
  CSD02 = 'CSD02',
  CSD03 = 'CSD03',
  BENEFIT_T1 = 'Benefit_T1',
  BENEFIT_T2 = 'Benefit_T2',
  BENEFIT_T3 = 'Benefit_T3',
  BENEFIT_T4 = 'Benefit_T4',
  BENEFIT_T5 = 'Benefit_T5',
  BENEFIT_B1 = 'Benefit_B1',
  BENEFIT_B2 = 'Benefit_B2',
  BENEFIT_B3 = 'Benefit_B3',
  BENEFIT_B4 = 'Benefit_B4',
  BENEFIT_B5 = 'Benefit_B5',
  VSTITLE = 'VS_TITLE',
  VS_T_00 = 'VS_T_00',
  VS_T_01 = 'VS_T_01',
  VS_T_02 = 'VS_T_02',
  VS_T_03 = 'VS_T_03',
  VS_T_04 = 'VS_T_04',
  VS_T_05 = 'VS_T_05',
  VS_E_00 = 'VS_E_00',
  VS_E_01 = 'VS_E_01',
  VS_E_02 = 'VS_E_02',
  VS_E_03 = 'VS_E_03',
  VS_E_04 = 'VS_E_04',
  VS_E_05 = 'VS_E_05',
  FLOW_TITLE = 'FLOW_TITLE',
  FLOW_TITLE1 = 'FLOW_TITLE1',
  FLOW_STEP1 = 'FLOW_STEP1',
  FLOW_STEP2 = 'FLOW_STEP2',
  FLOW_STEP3 = 'FLOW_STEP3',
  FLOW_STEP4 = 'FLOW_STEP4',
  QUICKCLAIMRM01 = 'QUICKCLAIMRM01',
  QUICKCLAIMRM02 = 'QUICKCLAIMRM02',
  QUICKCLAIMRM03 = 'QUICKCLAIMRM03',
  MOBDEVRM04 = 'MOBDEVRM04',
  M020 = 'M020',
  MPH = 'MPH',
  MPH01 = 'MPH01',
  MPH02 = 'MPH02',
  MPH03 = 'MPH03',
  MPH04 = 'MPH04',
  MPH05 = 'MPH05',
  MPH06 = 'MPH06',
  FIREPROPRM01 = 'FIREPROPRM01',
  I01_01 = 'I01_01',
  I01_02 = 'I01_02',
  I02_01 = 'I02_01',
  I02_02 = 'I02_02',
  I03_01 = 'I03_01',
  I03_02 = 'I03_02',
  I04_01 = 'I04_01',
  I04_02 = 'I04_02',
  I05_01 = 'I05_01',
  I05_02 = 'I05_02',
  NOTE_01 = 'NOTE_01',
  NOTE_02 = 'NOTE_02',
  NOTE_03 = 'NOTE_03',
  NOTE_04 = 'NOTE_04',
  NOTE_I01_01 = 'NOTE_I01_01',
  NOTE_I01_02 = 'NOTE_I01_02',
  NOTE_I01_03 = 'NOTE_I01_03',
  NOTE_I02_01 = 'NOTE_I02_01',
  NOTE_I02_02 = 'NOTE_I02_02',
  NOTE_I02_03 = 'NOTE_I02_03',
  NOTE_I02_04 = 'NOTE_I02_04',
  NOTE_I03_01 = 'NOTE_I03_01',
  NOTE_I03_02 = 'NOTE_I03_02',
  NOTE_I03_03 = 'NOTE_I03_03',
  NOTE_I03_04 = 'NOTE_I03_04',
  NOTE_I04_01 = 'NOTE_I04_01',
  NOTE_I04_02 = 'NOTE_I04_02',
  NOTE_I04_03 = 'NOTE_I04_03',
  NOTE_I05_01 = 'NOTE_I05_01',
  NOTE_I05_02 = 'NOTE_I05_02',
  NOTE_I05_03 = 'NOTE_I05_03',
  W081 = 'W081',
  PET01 = 'PET01',
  W087 = 'W087',
  CARRM07 = 'CARRM07'
}
